import { billOfMaterialsLocationIdFormat } from "@redotech/redo-fulfillment-id";
import * as z from "zod";

const UpdateBillOfMaterialsLocationInput_ = z.object({
  billOfMaterialsLocationId: billOfMaterialsLocationIdFormat.schema,
  enabled: z.boolean().optional(),
});
export const UpdateBillOfMaterialsLocationInput: z.ZodType<UpdateBillOfMaterialsLocationInput> =
  UpdateBillOfMaterialsLocationInput_;
export interface UpdateBillOfMaterialsLocationInput extends z.infer<
  typeof UpdateBillOfMaterialsLocationInput_
> {}

export const updateBillOfMaterialsLocation = {
  name: "updateBillOfMaterialsLocation" as const,
  input: UpdateBillOfMaterialsLocationInput,
  output: z.object({ success: z.boolean() }),
};
